/** Sample data for the landing vignettes. Every vignette that shows it is labelled "Sample data". */

export const SAMPLE_REPORT = {
  title: 'Customer feedback, Q3',
  responses: 148,
  questions: 6,
  nps: { promoters: 82, passives: 41, detractors: 25 },
  bars: [
    { label: 'A friend', count: 52 },
    { label: 'Search', count: 41 },
    { label: 'Social media', count: 29 },
    { label: 'Other', count: 11 },
  ],
  steps: [
    { q: 'Q.01', title: 'How likely are you to recommend us?', reached: 164 },
    { q: 'Q.02', title: 'How did you hear about us?', reached: 151 },
    { q: 'Q.03', title: 'What nearly stopped you from signing up?', reached: 131 },
    { q: 'Q.04', title: 'Anything else we should know?', reached: 124 },
  ],
  started: 164,
  completed: 148,
  summary:
    'Most people would recommend you and found you through a friend. The comments that mention setup ask for a shorter first step.',
}

export const SAMPLE_QUESTIONS = [
  { type: 'Multiple choice', title: 'How did you hear about us?' },
  { type: 'Rating 0 to 10', title: 'How likely are you to recommend us?' },
  { type: 'Long text', title: 'What nearly stopped you from signing up?' },
]

export const SAMPLE_PROMPT =
  'A short survey for people who just attended our product webinar. I want to know what they liked and what to cover next.'

export const SAMPLE_DRAFT = [
  { type: 'Rating', title: 'How useful was the webinar?' },
  { type: 'Checkboxes', title: 'Which parts did you like?' },
  { type: 'Long text', title: 'What should we cover next?' },
]

export const WEBHOOK_TARGETS = ['Zapier', 'Make', 'n8n', 'Slack', 'Any URL']

/** Hero builder: sample answers to SAMPLE_QUESTIONS[2], grouped under one theme. Labelled "Sample" on the page. */
export const SAMPLE_THEME = {
  label: 'First step too long',
  question: 2,
  responses: [
    'I nearly quit at the sign-up step.',
    'Too much to fill in before I could look around.',
    'A shorter first step would have helped.',
  ],
}
